import axios from "axios";

const getThisUser = (hook) => {
    const token = localStorage.getItem('access_token');
    axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/user-info/`,{
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    .then((response) => {
        hook(response.data);
    })
    .catch((error) => {
        console.error("Failed to fetch user info:", error);
    });
};

export default getThisUser;